<template src="../templates/normal_fcont_105.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  data() {
    return {
      articleId: '105',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['105-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['105-2']}
    ]};

  }
};
</script>
<style >

</style>

